export const currencyCodeToSymbol = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  // Add more currency symbols as needed
};

export const currencyConversionRates = {
  EUR: { EUR: 1, USD: 1.07, GBP: 0.86 },
  USD: { EUR: 0.906, USD: 1, GBP: 0.8 },
  GBP: { EUR: 1.154, USD: 1.25, GBP: 1 },
  // Add more currency conversion as needed
};
